import {
  Css_HeadingH4_tw,
  HeadingH1,
  HeadingH4,
} from '@dreamstack/feature-components/src/layout/Texts'
import type { BlockTable } from '@dreamstack/payload/src/payload-types'
import { cn } from '@dreamstack/util'
import head from 'lodash/head'
import map from 'lodash/map'
import tail from 'lodash/tail'
import type { FunctionComponent } from 'react'

export const TableDefault: FunctionComponent<
  React.PropsWithChildren<{
    block: BlockTable
  }>
> = ({ block }) => {
  const { title, table } = block
  const tableData =
    (table as { tableData?: string[][] } | null)?.tableData ?? null
  const headData: string[] = head(tableData) || []
  const rowData: string[][] = tail(tableData) || [[]]
  return (
    <div className="w-full mt-px-48 md:mt-px-80">
      {title && <HeadingH1 className="mb-px-24">{title}</HeadingH1>}
      <div className="w-full overflow-auto">
        <table className="w-full">
          {!!headData?.length && (
            <thead>
              <tr className="border-b-2 border-accentroGray-full font-semibold">
                {map(headData, (headDataEntry, i) => (
                  <th className="text-left p-px-24" key={i}>
                    <HeadingH4>{headDataEntry}</HeadingH4>
                  </th>
                ))}
              </tr>
            </thead>
          )}
          <tbody>
            {map(rowData, (rowEntry, i) => (
              <tr key={i}>
                {map(rowEntry, (rowEntryData, i) => (
                  <td
                    className={cn(`p-px-24`, Css_HeadingH4_tw)}
                    key={`rowdataentry${i}`}
                  >
                    {rowEntryData}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
